export class LazyLoader {
    private dotNetReference: any;
    private contextRef: HTMLElement;
    private observer: IntersectionObserver;
    private scrollElementId: string | undefined;
    private isLoading: boolean = false;

    constructor(dotNetRef: any, elementRef: HTMLElement, scrollElementId: string | undefined) {
        this.dotNetReference = dotNetRef;
        this.contextRef = elementRef;

        this.initIntersectionObserver();

        const debouncedScrollHandler = this.debounce(this.handleScroll.bind(this), 200);
        document.addEventListener("scroll", debouncedScrollHandler);

        if (!this.scrollElementId) {
            document.getElementsByTagName("main")[0].addEventListener("scroll", debouncedScrollHandler);
        } else {
            document.getElementById(this.scrollElementId)?.addEventListener("scroll", debouncedScrollHandler);
        }
    }

    private initIntersectionObserver() {
        const options = {
            root: null,
            threshold: 0.1
        };

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
    }

    private debounce(func: Function, delay: number) {
        let timeout: number;
        return function (...args: any[]) {
            clearTimeout(timeout);
            timeout = window.setTimeout(() => func.apply(this, args), delay);
        };
    }

    public handleScroll() {

        if (!this.contextRef) {
            return;
        }

        if (!this.contextRef.parentElement) {
            return;
        }

        if (!this.contextRef.parentElement.children) {
            return;
        }

        const children = Array.from(this.contextRef.parentElement.children).filter(e => !e.className.includes("lazy-loading"));
        const nthLastElementVisibleStartLoading = 2;
        const elementToCheck = children.length > nthLastElementVisibleStartLoading ?
            children[children.length - nthLastElementVisibleStartLoading - 1] : children[children.length - 1];

        if (elementToCheck === undefined) {
            return;
        }

        this.observer.observe(elementToCheck);
    }


    private async handleIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(async entry => {
            if (entry.isIntersecting && !this.isLoading) {
                this.isLoading = true;
                await this.dotNetReference.invokeMethodAsync("LoadDataAsync");
                this.isLoading = false;
                this.handleScroll();
            }
        });
    }
}

window['InitLazyLoading'] = function (dotNetRef: any, elementRef: HTMLElement, scrollElementId: string | undefined) {
    return new LazyLoader(dotNetRef, elementRef, scrollElementId);
};